// Centralized constants and configuration
import { ethers } from 'ethers';

export const SUBGRAPH_URL = 'https://gateway.thegraph.com/api/subgraphs/id/85h5uXQmtNcYuaYbJ5JrKukbBM7v5FnckhEfLbMM8XXH';
export const API_KEY = 'ef70e2cb627a07b403b6282138deee1a';
export const HEADERS = { Authorization: `Bearer ${API_KEY}` };

export const ARBITRUM_RPC = 'https://arb1.arbitrum.io/rpc';
export const provider = new ethers.providers.JsonRpcProvider(ARBITRUM_RPC);

export const LIVECOINWATCH_API_KEY = '8a4a1411-868c-4972-b9e9-d2ea01626f8d';
export const CACHE_DURATION = 300000; // 5 minutes
export const NETWORK_ID = 42161; // Arbitrum One

// Known tokens on Arbitrum with decimals
export const addressToTokenInfo = {
  "0x82af49447d8a07e3bd95bd0d56f35241523fbab1": { symbol: "WETH", decimals: 18 },
  "0xff970a61a04b1ca14834a43f5de4533ebddb5cc8": { symbol: "USDC.e", decimals: 6 },
  "0xaf88d065e77c8cc2239327c5edb3a432268e5831": { symbol: "USDC", decimals: 6 },
  "0xfd086bc7cd5c481dcc9c85ebe478a1c0b69fcbb9": { symbol: "USDT", decimals: 6 },
  "0x912ce59144191c1204e64559fe8253a0e49e6548": { symbol: "ARB", decimals: 18 },
  "0x2f2a2543b76a4166549f7aab2e75bef0aefc5b0f": { symbol: "BTC", decimals: 8 },
  "0x2bcc6d6cdbbdc0a4071e48bb3b969b06b3330c07": { symbol: "SOL", decimals: 9 },
  "0x11cdb42b0eb46d95f990bedd4695a6e3fa034978": { symbol: "CRV", decimals: 18 },
  "0xfc5a1a6eb076a2c7ad06ed22c90d7e710e35ad0a": { symbol: "GMX", decimals: 18 },
};
